/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tfr-details__minor-header[_ngcontent-%COMP%]{font-weight:700}p[_ngcontent-%COMP%]{margin-bottom:1rem}"];
export { styles as styles };
